'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _array = require('array.dedup');

var _array2 = _interopRequireDefault(_array);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isArray = Array.isArray;
var keys = Object.keys;

var mixClass = function mixClass() {
    var classes = [];
    var args = arguments;
    keys(args).forEach(function (key) {
        var arg = args[key];
        if (!arg) {
            return;
        }
        var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
        if (argType === 'string' || argType === 'number') {
            classes.push(arg);
        } else if (isArray(arg)) {
            classes.push(mixClass.apply(null, arg));
        } else if (argType === 'object') {
            keys(arg).forEach(function (k) {
                if (arg[k]) {
                    classes.push(k);
                }
            });
        }
    });
    var cookClasses = [];
    classes.forEach(function (c) {
        return cookClasses = cookClasses.concat(c.split(' '));
    });
    return (0, _array2.default)(cookClasses).join(' ');
};

exports.default = mixClass;
module.exports = exports['default'];